<template>

  <template v-if="session && adminPortalData && adminPortalPrimaryProduct">
    <template v-if="currentScheme === 'ecoamaps'">
      <legacy-your-profile-component :session="session" :admin-portal-data="adminPortalData" :admin-portal-primary-product="adminPortalPrimaryProduct"/>
    </template>
    <template v-else>
      <your-profile-component :session="session" :admin-portal-data="adminPortalData" :admin-portal-primary-product="adminPortalPrimaryProduct"/>
    </template>
  </template>

</template>

<script>
import LegacyYourProfileComponent from "@/components/your-profile-legacy/your-profile-component.vue"
import YourProfileComponent from "@/components/your-profile/your-profile-component.vue"
import {useRoute} from "vue-router";

export default {
  components: {LegacyYourProfileComponent},

  props: [
    'session',
    'adminPortalData',
    'adminPortalPrimaryProduct'
  ],

  setup() {
    const route = useRoute();
    return {route}
  },

  computed: {
    currentScheme() {
      return this.route.params.scheme;
    },
  }
}
</script>
